'use client';
import { useEffect, useRef } from 'react';
import { useRouter } from 'next/navigation';
import { useModal } from '@/components/hook/modal';
import LoginModal from '@/components/modal/LoginModal/LoginModal';

type Props = {
  email: string;
};

function PriveeInviteAutoOpen({ email }: Props) {
  const router = useRouter();
  const modalTools = useModal();
  const openedRef = useRef(false);

  useEffect(() => {
    if (openedRef.current) return;
    openedRef.current = true;
    modalTools.showModal(
      <LoginModal
        headline='Log in to accept your Réservé invitation'
        initialValues={{ username: email, password: '' }}
        onClose={modalTools.closeModal}
        onSubmitSuccess={() => {
          modalTools.closeModal();
          router.refresh();
        }}
        onNavigateClick={modalTools.closeModal}
      />,
      { topClassName: 'bg-gold' }
    );
  }, []);

  return null;
}

export default PriveeInviteAutoOpen;
